import View from '../../../Core/View.js';

class FaqAccordion extends View {

	/**
	 * @var {string}
	 */
	static OPEN_STATE_CLASS = 'faq-accordion__list-item--open';

	/**
	 *
	 */
	initialize() {
		this.$listItems = this.$el.find('.faq-accordion__list-item');
		this.$el.on('click', '.faq-accordion__question', this.handleQuestionClick.bind(this));
	}

	/**
	 * @param {Event} event
	 */
	handleQuestionClick(event) {
		event.preventDefault();
		event.stopPropagation();

		this.toggleQuestionListItem($(event.currentTarget.parentNode));
	}

	/**
	 * @param {jQuery} $listItem
	 */
	toggleQuestionListItem($listItem) {
		if ($listItem.hasClass(FaqAccordion.OPEN_STATE_CLASS)) {
			this.close($listItem);
			return;
		}

		var $currentListItem = this.$listItems.filter('.' + FaqAccordion.OPEN_STATE_CLASS);
		this.close($currentListItem, () => {
			this.open($listItem);
		});
	}

	/**
	 * @param {jQuery} $listItem
	 */
	open($listItem) {
		$listItem
			.addClass(FaqAccordion.OPEN_STATE_CLASS)
			.find('.faq-accordion__answer')
			.slideDown(200);
	}

	/**
	 * @param {jQuery} $listItem
	 * @param {Function} [callBack]
	 */
	close($listItem, callBack) {
		if ($listItem.length === 0) {
			return callBack();
		}

		$listItem
			.removeClass(FaqAccordion.OPEN_STATE_CLASS)
			.find('.faq-accordion__answer')
			.slideUp(100, callBack);
	}
}

export default FaqAccordion;


// WEBPACK FOOTER //
// ./js/Views/Modules/FaqAccordion/FaqAccordion.js